// extracted by mini-css-extract-plugin
export default {"uploadInput":"styles_uploadInput__ziivU"};